<i18n src="./translations"></i18n>

<template>
  <div class="deshop-social" :class="classes" :data-preload="[$options.name]">
    <div class="deshop-social__app-links app-links">
      <span class="deshop-social__headline">
        {{ $t('deshop-social.title.mobile-apps') }}
      </span>
      <a
        href="https://app.adjust.com/gy92yvb"
        class="app-links__store-link"
        rel="noreferrer noopener"
        target="_blank"
        :title="$t('deshop-social.title.apple-store')"
      >
        <Icon name="apple_store" :inline="false" :lazy="true" />
      </a>
      <a
        href="https://app.adjust.com/gy92yvb"
        class="app-links__store-link"
        rel="noreferrer noopener"
        target="_blank"
        :title="$t('deshop-social.title.google-play-store')"
      >
        <Icon name="google_play_store" :inline="false" :lazy="true" />
      </a>
    </div>
    <div
      v-if="socialMediaList.length"
      class="deshop-social__media-links media-links"
    >
      <span class="deshop-social__headline">
        {{ title }}
      </span>
      <a
        v-for="(social, index) in socialMediaList"
        :key="index"
        class="media-links__item qa-IconButton"
        rel="noreferrer noopener"
        target="_blank"
        :href="social.url"
        :title="social.title"
      >
        <Icon :name="`${social.icon}_deshop`" :inline="false" :lazy="true" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from 'Components/00-generated/Icon';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'DeshopSocial',
  components: {
    Icon,
  },
  mixins: [globalMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('core', {
      socialMediaList: ({ navigation }) => navigation.social,
    }),
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';

.deshop-social {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
}

.deshop-social__headline {
  display: block;
  white-space: nowrap;
  font-weight: bold;
  font-size: var(--font-size-M);
  color: var(--color-mine-shaft);
  line-height: 30px;
  text-align: left;
}

.media-links__item {
  display: inline-flex;

  & + & {
    margin-left: 8px;
  }

  &:hover {
    background: var(--color-alabaster);
  }
}

.deshop-social__app-links {
  display: inline-block;
  margin-right: var(--space-2);
  margin-bottom: var(--space-2);
}

.app-links__store-link {
  display: inline-block;
  height: 35px;

  &:hover {
    img {
      transform: scale(1.1);
    }
  }

  & + & {
    margin-left: var(--space-1);
  }

  img {
    transition: transform var(--time-XS) ease-out;

    height: 100%;
  }
}

@media #{$_mediaMDown} {
  .deshop-social {
    align-items: flex-start;
  }

  .media-links__item {
    flex-grow: 0;
    -ms-flex-positive: 1;
  }
}

@media #{$_mediaSDown} {
  .deshop-social__headline {
    text-align: left;
  }
}
</style>
